export default {
  TweetListPage_getScPos (state) {
    const listType = state.TweetListPage.listType
    return state.TweetListPage.scrollTop[listType] || 0
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js